var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ApiUrl, AuthorizationHeaders } from 'api/environment';
import { assertWriteAccess, checkReadOnlyResponse } from 'api/readOnlyAccess';
import { toastOnError } from 'utils/http';
export function withAttachments(mutation) {
    return ((params) => __awaiter(this, void 0, void 0, function* () {
        assertWriteAccess();
        const upload = (file) => __awaiter(this, void 0, void 0, function* () {
            const body = new FormData();
            body.append('file', file);
            return fetch(`${ApiUrl}/upload`, {
                method: 'POST',
                headers: AuthorizationHeaders(),
                body,
            })
                .then(checkReadOnlyResponse)
                .then(toastOnError)
                .then((response) => response.text());
        });
        const isMentionDataArray = (val) => {
            if (!Array.isArray(val))
                return false;
            return val.every((item) => item &&
                typeof item === 'object' &&
                'id' in item &&
                typeof item.id === 'string' &&
                'username' in item &&
                typeof item.username === 'string');
        };
        const variables = Object.fromEntries(yield Promise.all(Object.entries((params === null || params === void 0 ? void 0 : params.variables) || {}).map((_a) => __awaiter(this, [_a], void 0, function* ([name, value]) {
            if (value instanceof File)
                return upload(value).then((ref) => [name, ref]);
            if (Array.isArray(value)) {
                if (isMentionDataArray(value))
                    return Promise.resolve([name, value]);
                const isArrayOfFiles = value.every((v) => v instanceof File);
                if (isArrayOfFiles)
                    return Promise.all(value.map((file) => upload(file))).then((refs) => [name, refs]);
                return Promise.resolve([name, value]);
            }
            return Promise.resolve([name, value]);
        }))));
        return mutation(Object.assign(Object.assign({}, params), { variables }));
    }));
}
export default withAttachments;
